import { ReactHookFormMarkDown } from "components/base/CustomMarkDownArea";
import ReactHookFormSwitch from "components/reactHookFormComponents/ReactHookFormSwitch";
import ReactHookFormTitleWithRadio from "components/reactHookFormComponents/ReactHookFormTitleWithRadio";
import OverviewSection from "components/segment/OverviewSection";
import SegmentConditionGroupsInputSection from "components/segment/SegmentConditionGroupsInputSection";
import { DISPLAY_SEGMENT_TYPE, DISPLAY_STATIC_SEGMENT_CUSTOMER_SOURCE, SEGMENT_TYPE, STATIC_SEGMENT_CUSTOMER_SOURCE } from "config/CustomEnums";
import TargetCustomerSection from "components/customerGroup/TargetCustomerSection";

import i18n from '../../../I18n';

export const SEGMENT_CREATION_STEP_ONE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    const segmentType = watch("segmentType")
    const staticSegmentCustomerSource = watch("staticSegmentCustomerSource")
    const displayNormalSectionComponents = [
      "segment_type_selector_key",
      "segment_name_input_key",
      "blacklist_segment_switch_key",
    ]
    const displayLanguageSectionComponents = []
    if (segmentType === SEGMENT_TYPE.STATIC) {
      displayNormalSectionComponents.push(
        "descriprion_key",
        "show_as_customer_tag_key",
        "customer_source_selector_key",
      )
    }
    if (segmentType === SEGMENT_TYPE.DYNAMIC
      || (
        segmentType === SEGMENT_TYPE.STATIC
        && staticSegmentCustomerSource === STATIC_SEGMENT_CUSTOMER_SOURCE.CONDITION
      )) {
      displayNormalSectionComponents.push(
        "segment_condition_groups_input_key",
      )
    }
    if (segmentType === SEGMENT_TYPE.STATIC
      && staticSegmentCustomerSource === STATIC_SEGMENT_CUSTOMER_SOURCE.CUSTOMER_NAME) {
      displayNormalSectionComponents.push(
        "customer_name_selector_key",
      )
    }
    return {
      displayNormalSectionComponents,
      displayLanguageSectionComponents
    }
  },
  languageSections: [],
  normalSections: [
    {
      sectionTitle: "GENERAL",
      sectionContent: [
        {
          key: "segment_name_input_key",
          component: OverviewSection,
        },
        {
          key: "segment_type_selector_key",
          component: ReactHookFormTitleWithRadio,
          componentProps: {
            title: "Type",
            valueFieldName: "segmentType",
            defaultValue: SEGMENT_TYPE.DYNAMIC,
            options: [SEGMENT_TYPE.DYNAMIC, SEGMENT_TYPE.STATIC].map(item => ({
              label: DISPLAY_SEGMENT_TYPE?.[item] || item, value: item
            })),
            bottomDescription: "A dynamic segment is a customer list that is managed by the system and automatically updated. With each update, customers who meet specific criteria will be added to the list, while those who no longer fulfill these criteria will be removed."
          },
        },
        {
          key: "descriprion_key",
          component: ReactHookFormMarkDown,
          componentProps: {
            content: {
              label: i18n.t('description_optional'),
              error: false,
              key: "description",
              focus: () => { },
            }
          },
        },
        {
          key: "show_as_customer_tag_key",
          component: ReactHookFormSwitch,
          componentProps: {
            title: "Show in Customer profile as 'Customer tag'",
            valueFieldName: 'showInCustomerProfile',
          },
        },
        {
          key: "blacklist_segment_switch_key",
          component: ReactHookFormSwitch,
          componentProps: {
            title: "Mark as blacklist segment",
            valueFieldName: "isBlacklistSegment",
            tips: "A blacklist segment is used to exclude customers who meet certain conditions. It can be applied to any campaign or earning rules.",
            titlePopoverDetail: "Customers in a blacklist segment are unable to participate in the assigned campaigns (e.g., earning rewards or acquiring coupons), but they can still view the campaigns on the front end if the campaign is in visible period.",
          },
        }
      ]
    },
    {
      sectionTitle: "TARGET CUSTOMER",
      sectionContent: [
        {
          key: "customer_source_selector_key",
          component: ReactHookFormTitleWithRadio,
          componentProps: {
            title: "Select customers",
            valueFieldName: "staticSegmentCustomerSource",
            defaultValue: STATIC_SEGMENT_CUSTOMER_SOURCE.CUSTOMER_NAME,
            options: [STATIC_SEGMENT_CUSTOMER_SOURCE.CUSTOMER_NAME, STATIC_SEGMENT_CUSTOMER_SOURCE.CONDITION].map(item => ({
              label: DISPLAY_STATIC_SEGMENT_CUSTOMER_SOURCE?.[item] || item, value: item
            })),
            bottomDescription: "After the condition is selected, customers that fulfilled the conditions will be added to the segment automatically."
          },
        },
        {
          key: "customer_name_selector_key",
          component: TargetCustomerSection,
        },
        {
          key: "segment_condition_groups_input_key",
          component: SegmentConditionGroupsInputSection,
        }
      ]
    },
  ],
}